export default (name = 'Tipply') =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=0078ff&color=fff`;
